module.exports = __webpack_public_path__ + "static/img/model4.cd5e4fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/model4.png
// module id = qb/N
// module chunks = 2